import React from 'react';

export const Spacer = ({ className, ...props }) => (
  <div className={`${className}`} {...props} />
);
